import * as React from "react";
const SvgFiRrOnboarding = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-onboarding_svg__a)">
      <path
        fill="#062147"
        d="M6 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m-.284 6.698c1.508-1.545 4.061-1.545 5.568 0a.997.997 0 0 0 1.414.018 1 1 0 0 0 .018-1.414C11.582 6.64 10.085 6 8.5 6s-3.082.64-4.216 1.802a.999.999 0 1 0 1.432 1.396m17.52 3.817-6.804 7.637A10 10 0 0 1 8.965 24H4c-2.206 0-4-1.794-4-4v-5c0-2.206 1.794-4 4-4h8.857a3.14 3.14 0 0 1 2.689 1.519l3.217-3.534a3 3 0 0 1 2.085-.981 3.04 3.04 0 0 1 2.169.782 3.02 3.02 0 0 1 .218 4.23zm-1.565-2.752a.98.98 0 0 0-.728-.263c-.27.013-.519.13-.7.329l-4.426 4.865a3.16 3.16 0 0 1-2.514 2.058l-5.161.737a1.001 1.001 0 0 1-.283-1.981l5.161-.737c.56-.079.98-.565.98-1.13 0-.63-.513-1.143-1.143-1.143H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h4.965a8.02 8.02 0 0 0 5.974-2.678l6.804-7.638a1.014 1.014 0 0 0-.072-1.421z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-onboarding_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOnboarding;
